import ToastComponent from "#sitis/components/Toast/Component.vue";
import { createComponent } from "#sitis/utils/toast";
import { defineNuxtPlugin } from "#imports";
const defaultProps = {
  position: "top-right"
};
const toast = defineNuxtPlugin((nuxtApp) => {
  const onOpen = function(options) {
    const propsData = { ...defaultProps, ...options };
    createComponent(ToastComponent, options, document.body);
  };
  const onSuccess = function(message, options) {
    return onOpen({
      ...options,
      message: message || options?.message,
      type: "success"
    });
  };
  const onError = function(message, options) {
    return onOpen({
      ...options,
      message: message || options?.message,
      type: "error"
    });
  };
  const onWarning = function(message, options) {
    return onOpen({
      ...options,
      message: message || options?.message,
      type: "warning"
    });
  };
  const onInfo = function(message, options) {
    return onOpen({
      ...options,
      message: message || options?.message,
      type: "info"
    });
  };
  const onDefault = function(message, options) {
    return onOpen({
      ...options,
      message: message || options?.message,
      type: "default"
    });
  };
  const onPopUp = function(message, options) {
    return onOpen({
      ...options,
      message: message || options?.message,
      type: "pop-up"
    });
  };
  nuxtApp.provide("toast", {
    open: onOpen,
    success: onSuccess,
    error: onError,
    warning: onWarning,
    info: onInfo,
    default: onDefault,
    popUp: onPopUp
  });
});
export default toast;
